document.addEventListener('DOMContentLoaded', function() {
  // --- Settings ---
  var rawIds = window.swatchSampleIds;
  var variantId = window.sampleProductVariantId;
  if (!rawIds || !variantId) {
    console.warn('[Free Sample] Missing swatchSampleIds or sampleProductVariantId!');
    return;
  }

  var swatchIds = (typeof rawIds === 'string' ? rawIds.split(',').map(x => x.trim()).filter(Boolean) : []);
  if (!swatchIds.length) {
    console.warn('[Free Sample] No swatch IDs found!');
    return;
  }

  function insertButtons() {
    // Remove previous buttons
    document.querySelectorAll('.vb-buy-sample-btn').forEach(b => b.remove());
    let count = 0;

    swatchIds.forEach(function(id) {
      var img = document.querySelector('img[alt="' + id + '"]');
      if (img) {
        var label = img.closest('label.cl-po--swatch-item');
        if (label && !label.querySelector('.vb-buy-sample-btn')) {
          var btn = document.createElement('button');
          btn.textContent = 'Free Sample';
          btn.type = 'button';
          btn.className = 'vb-buy-sample-btn';
          btn.style.display = 'block';
          btn.style.margin = '6px auto 0';
          btn.style.background = '#111';
          btn.style.color = '#fff';
          btn.style.border = '1px solid #333';
          btn.style.cursor = 'pointer';
          btn.style.fontSize = '12px';
          btn.style.padding = '3px 8px';
          btn.style.borderRadius = '4px';
          btn.style.textAlign = 'center';
          btn.style.width = 'auto';
          btn.style.maxWidth = '90px';

          btn.onclick = function() {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: variantId,
                quantity: 1,
                properties: { 'Swatch ID': id }
              })
            }).then(function(resp) {
              if (resp.ok) btn.textContent = 'Added!';
              setTimeout(function(){ btn.textContent = 'Free Sample'; }, 1200);
            }).catch(function() {
              alert('Could not add sample to cart. Please try again.');
            });
          };

          label.appendChild(btn);
          count++;
        }
      }
    });
   }

  // For swatch apps that rerender, watch the swatch container for changes
  var container = document.querySelector('.cl-po--swatch-container');
  if (container) {
    var mo = new MutationObserver(insertButtons);
    mo.observe(container, { childList: true, subtree: true });
  }

  // Initial run and after lazyload
  insertButtons();
  setTimeout(insertButtons, 1500);
});
